export default __webpack_public_path__ + "static/banner-city-36e7e539f85c579895ace888387556e0.jpg";